<script lang="ts">
import type { ChatAnnotation, ChatRole, ContentBlock } from '#layers/ai/types/chat';

export interface ContentBlockTextProps extends ContentBlock<'text'> {
	text: string;
	annotations?: ChatAnnotation[];
}
</script>

<script lang="ts" setup>
import { Markdown } from '@comark/vue';

defineProps<ContentBlockTextProps & { role: ChatRole }>();
</script>

<template>
	<div
		:class="role === 'user'
			? `
				relative ml-auto min-h-12 max-w-11/12 min-w-0 space-y-4 rounded-lg bg-elevated/50 px-4 py-3 text-pretty
				*:first:mt-0
				*:last:mb-0
			`
			: undefined"
	>
		<Markdown
			streaming
			class="prose prose-sm max-w-none leading-6 prose-p:my-0 prose-ol:my-3 prose-ul:my-3 prose-li:my-1"
		>
			{{ text }}
		</Markdown>
	</div>
</template>
